/**
 * Close Header Notion
 */
const closeNotion = () => {
  $('.header__notice').on('click', '.header__notice-close', function(event) {
    $(this).closest('.header__notice').slideUp(400, 'linear');

    $('.main').css('padding-top', $('.header').outerHeight() - $('.header__notice').outerHeight());

    event.preventDefault();
  });
}

closeNotion();
